import { useContext } from 'react';
import FavoritesContext from '../store/favorites-context';
import NoteList from '../notes/NoteList';

function FavoritesPage() {
    const favoriteCtx = useContext(FavoritesContext);

    let context;

    if (favoriteCtx.totalFavorites === 0) {
        context = <p>You got no favorites yet. Start adding some?</p>
    }
    else {
        context = <NoteList notes={favoriteCtx.favorites}/>
    }

    return (
        <section>
        <h1>My Favorites</h1>
        {context}
        </section>
    );
}

export default FavoritesPage;